import { render } from "./cropRect.vue?vue&type=template&id=bc1712ae&scoped=true"
import script from "./cropRect.vue?vue&type=script&lang=js"
export * from "./cropRect.vue?vue&type=script&lang=js"

import "./cropRect.vue?vue&type=style&index=0&id=bc1712ae&scoped=true&lang=css"

import exportComponent from "C:\\vue2023\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1712ae"]])

export default __exports__